export enum BonusStatus {
	New = 1,
	COUPON_ISSUED = 2,
	REDEEMED = 3,
	REDEEM_FAILED = 4, 
	COUPON_ISSUE_FAILED = 5, 
	EXPIRED = 6, 
}